import { sharedSchema } from "@shared-database/pgSchema";
import { leoID, timestampColumns, leoEnum } from "@shared-database/utils";
import { AppEnumValues } from "@shared-database/enums";
import { unique, index, boolean, text } from "drizzle-orm/pg-core";
import { type InferInsertModel, type InferSelectModel } from "drizzle-orm";

const [...appFeatures] = AppEnumValues;

export const AppFeatureEnumValues = [...appFeatures] as const;

export type AppFeatureEnumType = (typeof AppFeatureEnumValues)[number];

export const AppFeatureEnum = leoEnum("AppEnum", AppFeatureEnumValues);

export const DegradedFeature = sharedSchema.table(
  "DegradedFeature",
  {
    ...timestampColumns,
    feature: AppFeatureEnum("feature").notNull(),
    degraded: boolean("degraded").notNull(),
    reason: text("reason").notNull(),
    id: leoID("id"),
  },
  (table) => [
    index("DegartedFeature_idIdx").on(table.id),
    index("DegartedFeature_featureIdx").on(table.feature),
    unique().on(table.feature),
  ],
);

export type DegradedFeatureType = InferSelectModel<typeof DegradedFeature>;
export type DegradedFeatureInsertType = InferInsertModel<
  typeof DegradedFeature
>;
